
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Loader2, BarChart3 } from 'lucide-react';
import { Card } from '../../ui/Card';
import { AreaChart } from '../../charts/AreaChart';
import { MainnetValidation } from './MainnetValidation';

interface AnalyticsCardProps {
    data: number[];
    isLoading: boolean;
}

export const AnalyticsCard: React.FC<AnalyticsCardProps> = ({ data, isLoading }) => {
    return (
        <Card noPadding className="h-[400px] sm:h-[520px] flex flex-col border-stone-200 dark:border-white/10 shadow-smooth rounded-sm bg-white dark:bg-[#15171C] overflow-hidden group">
            <div className="p-5 sm:p-8 pb-2 flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6 shrink-0">
                <div className="space-y-0.5 w-full sm:w-auto text-left">
                    <div className="flex items-center gap-2 mb-0.5 sm:mb-1">
                        <BarChart3 size={16} className="text-nobel-gold shrink-0" />
                        <h3 className="font-serif text-lg sm:text-2xl font-black text-[#0A0B0F] dark:text-white uppercase tracking-tighter leading-none">Revenue Overview</h3>
                    </div>
                    <p className="text-[9px] sm:text-[10px] font-black text-stone-400 uppercase tracking-widest opacity-60">Monthly Performance</p>
                </div>
                <div className="flex gap-1 p-1 bg-stone-100 dark:bg-white/5 rounded-sm w-full sm:w-auto">
                    {['7D', '30D', '1Y'].map(t => (
                        <button key={t} className={`flex-1 sm:flex-none px-3 sm:px-4 py-1.5 rounded-sm text-[9px] sm:text-[10px] font-black uppercase tracking-widest transition-all ${t === '30D' ? 'bg-white dark:bg-white/10 text-stone-900 dark:text-white shadow-sm' : 'text-stone-400 hover:text-stone-900 dark:hover:text-stone-200'}`}>{t}</button>
                    ))}
                </div>
            </div>
            
            <div className="flex-1 w-full min-h-0 relative px-2 sm:px-4 pb-1 sm:pb-2">
                {isLoading ? (
                    <div className="h-full flex items-center justify-center">
                        <Loader2 className="animate-spin text-stone-200" />
                    </div>
                ) : (
                    <AreaChart data={data} />
                )}
            </div>

            <MainnetValidation />
        </Card>
    );
};
